import { render, staticRenderFns } from "./JobsConsumer.vue?vue&type=template&id=32aacb36&"
import script from "./JobsConsumer.vue?vue&type=script&lang=js&"
export * from "./JobsConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports